import { RESTClient } from "fmko-ts-common";
import { WhitelistingVO } from "./RestTypes";
import CertTestAdminApp from "./CertTestAdminApp";

export default class SystemInfoService {
    static instance: SystemInfoService;

    baseUrl: string;
    restClient = new RESTClient({ version: undefined });

    public static getInstance(): SystemInfoService {
        if (!this.instance) {
            // var baseUrl = mod.mc().getConfiguration().getMinlogUrlBase();
            let baseUrl = "/fmk12/certtestrest/systeminfo";
            this.instance = new SystemInfoService(baseUrl);
        }

        return this.instance;
    }

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public getSystemWhitelistings(): Promise<Array<WhitelistingVO>> {
        let url = this.baseUrl + "/whitelistings";

        CertTestAdminApp.clearAlert();

        return this.restClient.get<Array<WhitelistingVO>>(url, "Henter whitelistings");
    }

}
